import AllAboutUs from '@components/sections/AllAboutUs'
import OurTeam from '@components/sections/OurTeam'
import heroBg from '@assets/images/HVACExperts_NiketEnggv2.jpg'
import styles from './WhoWeAre.module.css'

const WhoWeAre = () => {
  return (
    <div className={styles.whoWeAre}>
      <section
        className={styles.pageHero}
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className={styles.heroOverlay} />
        <div className={styles.heroContent}>
          <span className={styles.heroBadge}>About Nikket Engineering</span>
          <h1 className={styles.heroTitle}>
            Building Comfort.<br />Engineering Trust.
          </h1>
          <p className={styles.heroSubtitle}>
            Over 14 years of HVAC excellence for commercial & corporate spaces
          </p>
        </div>
      </section>
      <AllAboutUs />
      <OurTeam />
    </div>
  )
}

export default WhoWeAre
